// extracted by mini-css-extract-plugin
export default {"homeGrid":"styles_homeGrid__oGw3I"};